import { GzEnumFilterWebComponent } from './component/GzEnumFilterWebComponent';
import { WEB_COMPONENT_GZ_ENUM_FILTER } from '../../webcomponents.constants';

export { GzEnumFilterWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_ENUM_FILTER, GzEnumFilterWebComponent);

/**
 * Examples:
 * Basic enum filter; the selected labels will be displayed in the label; the default filter width is '160px' =>
 * <gz-enum-filter
 *  filterOptions="[]"
 *  searchPlaceholderString="Search"
 *  confirmActionButtonString="Ok"
 *  noSearchResultsString="No results found"
 *  listTitle="All"></gz-enum-filter>
 *
 * Enum filter with small label; the selected values will not be displayed in the label =>
 * <gz-enum-filter
 *  labelWidth="80"
 *  filterOptions="[]"
 *  searchPlaceholderString="Search"
 *  confirmActionButtonString="Ok"
 *  noSearchResultsString="No results found"
 *  listTitle="All"></gz-enum-filter>
 *
 *  Enum filter with label size variant =>
 * <gz-enum-filter
 *  labelWidth="240"
 *  filterOptions="[]"
 *  searchPlaceholderString="Search"
 *  confirmActionButtonString="Ok"
 *  noSearchResultsString="No results found"
 *  listTitle="All"></gz-enum-filter>
 *
 *  Enum filter with 'select-all' checkbox that toggles all/none selection =>
 * <gz-enum-filter
 *  labelWidth="240"
 *  canSelectAll
 *  allItemsLabel="All options"
 *  filterOptions="[]"
 *  searchPlaceholderString="Search"
 *  confirmActionButtonString="Ok"
 *  noSearchResultsString="No results found"
 *  listTitle="All"></gz-enum-filter>
 *
 */
